import { Component, OnInit } from '@angular/core';
import { HttpService } from '../../services/http-service/http.service';


interface IBanner{
  text: string,
  option: any
}

@Component({
  selector: 'app-notification-container',
  imports: [],
  templateUrl: './notification-container.component.html',
  styleUrl: './notification-container.component.scss'
})
export class NotificationContainerComponent implements OnInit{


  banners: IBanner[] = [];

  constructor(private http: HttpService){}

  ngOnInit(): void {

  }

}
